// extracted by mini-css-extract-plugin
export default {"helloworld":"Home_helloworld__8ByTn","overlay":"Home_overlay__qXQOU","popup":"Home_popup__XYx7K","topSeparator":"Home_topSeparator__k7eFa","bookNowA":"Home_bookNowA__xhpFW"};